import React, { useState, useEffect, useRef, useCallback } from 'react';
import './AIFeaturesSection.css';

const FEATURES = [
  { key: 'interview',  title: 'AI Interview Assistant',  path: '/InterviewAssistant', imageClass: 'interview-image'  },
  { key: 'resume',     title: 'AI Resume Builder',        path: '/BuildResume',         imageClass: 'resume-image'     },
  { key: 'quiz',       title: 'AI Cover Letter',          path: '/CoverLetter',         imageClass: 'cover-letter'     },
  { key: 'portfolio',  title: 'AI Portfolio Builder',     path: '/portfolio',           imageClass: 'paraphrase-image' },
  { key: 'career',     title: 'AI Quiz',                  path: '/CareerPathAdvisor',   imageClass: 'career-image'     },
];

const N = FEATURES.length;

const AIFeaturesSection = ({ user, setShowAuthModal, setMessage }) => {
  const [activeIdx, setActiveIdx] = useState(0);
  const timerRef = useRef(null);

  const resetTimer = useCallback((nextIdx) => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveIdx(prev => (prev + 1) % N);
    }, 3500);
    if (nextIdx !== undefined) setActiveIdx(nextIdx);
  }, []);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, [resetTimer]);

  const handleClick = (path) => {
    if (!user) {
      setShowAuthModal(true);
      setMessage('Please login to access this feature');
    } else {
      window.location.href = path;
    }
  };

  const getDiff = (i) => {
    let d = i - activeIdx;
    if (d > N / 2)  d -= N;
    if (d < -N / 2) d += N;
    return d;
  };

  const getStyle = (i) => {
    const d = getDiff(i);
    const abs = Math.abs(d);

    if (abs > 1) return { opacity: 0, pointerEvents: 'none', zIndex: 0, transition: 'all 0.75s ease-out' };

    const rotateY    = d * 55;
    const translateX = d * 68;
    const scale      = 1 - abs * 0.18;
    const opacity    = abs === 0 ? 1 : 0.88;
    const zIndex     = 10 - abs * 3;

    return {
      transform: `translate(-50%, -50%) translateX(${translateX}%) rotateY(${rotateY}deg) scale(${scale})`,
      opacity,
      zIndex,
      pointerEvents: 'auto',
      transition: 'all 0.75s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    };
  };

  return (
    <section className="ai-features" id="ai-features">
      <h1>Core Features</h1>
      <div className="ai-features-container">

        <div className="ai-features-nav">
          {FEATURES.map((f, i) => (
            <button
              key={f.key}
              className={`nav-btn${activeIdx === i ? ' active' : ''}`}
              onClick={() => resetTimer(i)}
            >
              {f.title}
            </button>
          ))}
        </div>

        <div className="coverflow-stage">
          {FEATURES.map((f, i) => (
            <div
              key={f.key}
              className={`cf-card${activeIdx === i ? ' cf-active' : ''}`}
              style={getStyle(i)}
              onClick={() => {
                if (activeIdx === i) handleClick(f.path);
                else resetTimer(i);
              }}
            >
              <div className={`card-image ${f.imageClass}`}>
                {getDiff(i) < 0 && <div className="cf-edge-shadow cf-edge-left" />}
                {getDiff(i) > 0 && <div className="cf-edge-shadow cf-edge-right" />}
                <div className="card-overlay">
                  <span className="visit-text">
                    Visit Page
                    <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M7 17L17 7M17 7H7M17 7V17"/>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cf-dots">
          {FEATURES.map((_, i) => (
            <button
              key={i}
              className={`cf-dot${activeIdx === i ? ' cf-dot-active' : ''}`}
              onClick={() => resetTimer(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default AIFeaturesSection;
